import React from "react";
import { Field } from "formik";
import {
  yesNoOptions,
  toOptionValuesFromMapper,
  returnOnlyIfBoolean,
  required,
  requiredWithErrorCode,
  ENROLLMENT_DROPDOWN_OPTIONS,
} from "../../../utils";
import {
  FieldButtonGroup,
  FieldDropSide,
  FieldInputNumber,
  SearchableList,
} from "../../../components";
import { get } from "lodash";

export const WindowPeriodFields = (props) => {
  const {
    fields,
    isSave,
    isEdit,
    values,
    setFieldValue,
    handleChange,
    autoEnrollment,
  } = props;
  return (
    <div>
      {/* <Field
        isRequired
        name={`autoEnrollment.${fields.isWindowPeriod}`}
        label="Does plan have an enrollment window period"
        size="sm"
        options={yesNoOptions}
        selectedValue={returnOnlyIfBoolean(
          get(values.autoEnrollment, fields.isWindowPeriod)
        )}
        onChange={(value) => {
          setFieldValue(`autoEnrollment.${fields.isWindowPeriod}`, value);
        }}
        disabled={isEdit && !isSave}
        component={FieldButtonGroup}
      /> */}
      <div>
        <div className="d-flex">
          <Field
            size="sm"
            name={`autoEnrollment.${fields.numberOfDaysWindowIsOpenNumber}`}
            label={"Number Of Days Window Is Open"}
            type="number"
            autoComplete="off"
            value={get(
              values.autoEnrollment,
              fields.numberOfDaysWindowIsOpenNumber
            )}
            onChange={handleChange}
            disabled={isEdit && !isSave}
            component={FieldInputNumber}
            max={999}
            min={1}
            isRequired
          />
          &nbsp;&nbsp;&nbsp;
          <div
            style={{
              marginLeft: "-2rem",
            }}
          >
            <Field
              size="lg"
              label=""
              isRequired
              name={`autoEnrollment.${fields.numberOfDaysWindowIsOpen}`}
              value={get(
                values.autoEnrollment,
                fields.numberOfDaysWindowIsOpen
              )}
              selectedValue={get(
                values.autoEnrollment,
                fields.numberOfDaysWindowIsOpen
              )}
              disabled={isEdit && !isSave}
              placeholder="Select a window period"
              options={toOptionValuesFromMapper(
                ENROLLMENT_DROPDOWN_OPTIONS.WINDOW_PERIOD
              )}
              popupContent={
                <SearchableList
                  label="Select Window is Open"
                  isNotTypeAhead
                  options={toOptionValuesFromMapper(
                    ENROLLMENT_DROPDOWN_OPTIONS.WINDOW_PERIOD
                  )}
                  onSelect={(value) => {
                    setFieldValue(
                      `autoEnrollment.${fields.numberOfDaysWindowIsOpen}`,
                      value
                    );
                  }}
                  selectedValue={get(
                    values.autoEnrollment,
                    fields.numberOfDaysWindowIsOpen
                  )}
                />
              }
              component={FieldDropSide}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WindowPeriodFields;
